<div class="d-flex gap-3" [formGroup]="parent">
  <ng-container formGroupName="orderHeader">
    <div>
      <!-- <jni-customer-account
        #customerAccount
        [parent]="parent"
        [deliveryAddress]="deliveryAddress"
        [orderType]="orderType"
        (customerBillToObjectEvent)="getCustomerBillToData($event)"
        (smallLoaderEvent)="getLoaderStatus($event)"
        [formErrors]="formErrors"
        (validationErrorEvent)="logValidationErrors()"
        (clearShipToEvent)="clearShipToForm()"
        (getBuyerEvent)="getAllBuyers()"
        (getProgramEvent)="getAllProgramByCustomerAccount($event)"
        [customerAccountNumber] = "customerAccountNumber"
      >
      </jni-customer-account> -->
      <jni-customer-account
        #customerAccount
        [parent]="parent"
        [deliveryAddress]="deliveryAddress"
        [orderType]="orderType"
        (customerBillToObjectEvent)="getCustomerBillToData($event)"
        (smallLoaderEvent)="getLoaderStatus($event)"
        [formErrors]="formErrors"
        (validationErrorEvent)="logValidationErrors()"
        (clearShipToEvent)="clearShipToForm()"
        (getBuyerEvent)="getAllBuyers()"
        (getProgramEvent)="getAllProgramByCustomerAccount($event)"
        [customerAccountNumber]="customerAccountNumber"
        [newSalesOrderCase]="newSalesOrderCase"
        (patchValueInCurrencyFieldEvent)="
          patchValueInCurrencyFieldEvent($event)
        ">
      </jni-customer-account>
    </div>
    <div>
      <jni-buyer
        #buyer
        [parent]="parent"
        [deliveryAddress]="deliveryAddress"
        (smallLoaderEvent)="getLoaderStatus($event)"
        [formErrors]="formErrors"
        (validationErrorEvent)="logValidationErrors()"
        (clearShipToEvent)="clearShipToForm()"
        (customerBillToObjectEvent)="getCustomerBillToData($event)"
        (getBuyerEvent)="getAllBuyers()">
      </jni-buyer>
    </div>
    <div class="d-flex justify-content-start col mt-3 pt-2 add-btn">
      <a
        *ngIf="customerBillToObject?.clientAccount"
        class="link-gray addNewClient nav-link link-gray d-flex justify-content-between align-items-center gap-1"
        (click)="addContactInformation()"
        ><i class="pi pi-plus"></i>Add</a
      >
    </div>
    <div>
      <div class="form-group has-float-label">
        <label class="form-label"
          >Job name<span class="madatory-field">*</span></label
        >
        <input
          pInputText
          hideOnDateTimeSelect="false"
          showTime="false"
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          formControlName="jobName"
          [ngClass]="{ 'has-error': formErrors['jobName'] }"
          (blur)="logValidationErrors()" />

        <span class="error-msg" *ngIf="formErrors['jobName']">
          {{ formErrors["jobName"] }}
        </span>
      </div>
    </div>
    <div>
      <jni-program
        #program
        [isSalesOrder]="true"
        [customerAccount]="customerAccountNumber"
        (programEvent)="getProgram($event)"
        (smallLoaderEvent)="getLoaderStatus($event)">
      </jni-program>
    </div>
    <div>
      <div class="form-group has-float-label">
        <label class="form-label">Ship date</label>
        <p-date-picker
          jniAutoCompleteBlocker
          inputId="basic"
          class="date-input"
          (onSelect)="onShipDateSelection($event)"
          formControlName="shipDate"
          [minDate]="shipDateCurrentdate"
          [ngClass]="{ 'has-error': formErrors['shipDate'] }"
          (onBlur)="logValidationErrors()"
          [showOtherMonths]="true"
          [selectOtherMonths]="true"
          [readonlyInput]="true"></p-date-picker>

        <span class="error-msg" *ngIf="formErrors['shipDate']">
          {{ formErrors["shipDate"] }}
        </span>
      </div>
    </div>
    <div>
      <div class="form-group has-float-label">
        <label class="form-label"
          >In-hands date <span class="madatory-field">*</span></label
        >
        <p-date-picker
          jniAutoCompleteBlocker
          inputId="basic"
          class="date-input"
          formControlName="inHandsDate"
          (onSelect)="onInHandDateSelection($event)"
          [defaultDate]="sharedMonthForView"
          [minDate]="inHandDateCurrentdate"
          [showOtherMonths]="true"
          [selectOtherMonths]="true"
          [ngClass]="{ 'has-error': formErrors['inHandsDate'] }"
          (onBlur)="logValidationErrors()"
          [readonlyInput]="true"></p-date-picker>

        <span class="error-msg" *ngIf="formErrors['inHandsDate']">
          {{ formErrors["inHandsDate"] }}
        </span>
      </div>
    </div>
    <div>
      <div class="form-group has-float-label">
        <label class="form-label"
          >Method of Payment<span class="madatory-field">*</span></label
        >
        <p-select
          pInputText
          id="methodOfPaymentHeader"
          formControlName="methodOfPaymentHeader"
          [ngClass]="{ 'has-error': formErrors['methodOfPaymentHeader'] }"
          (blur)="logValidationErrors()"
          (change)="getCreditCard($event)"
          [options]="customerPaymentMethodList"
          optionLabel="Name"
          optionValue="Name"
          [filter]="true"
          [showClear]="true">
        </p-select>

        <span class="error-msg" *ngIf="formErrors['methodOfPaymentHeader']">
          {{ formErrors["methodOfPaymentHeader"] }}
        </span>
      </div>
    </div>
    <div>
      <div class="form-group has-float-label">
        <label class="form-label"
          >Branding Consultant<span class="madatory-field">*</span></label
        >
        <input
          pInputText
          jniAutoCompleteBlocker
          type="text"
          id="brandingConsultant"
          name="brandingConsultant"
          class="form-control"
          formControlName="brandingConsultant"
          (click)="onBrandingConsultantSelection($event, bcPopOver)"
          [ngClass]="{ 'has-error': formErrors['brandingConsultant'] }"
          (blur)="logValidationErrors()" />

        <span class="error-msg" *ngIf="formErrors['brandingConsultant']">
          {{ formErrors["brandingConsultant"] }}
        </span>
      </div>
      <p-popover
        #bcPopOver
        aria-labelledby="dropdownBasic4"
        class="order-dropdown">
        <p-table
          #dt
          [value]="brandingConsultantLists"
          styleClass="p-datatable-customers order-listing"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0">
          <ng-template pTemplate="header">
            <tr>
              <th class="name">Project id</th>
              <th class="vaccount">Project name</th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-brandingConsultantList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row mousepointer"
              (click)="onProjectIdSelection(brandingConsultantList, bcPopOver)">
              <td class="name mousepointer">
                {{ brandingConsultantList.projectId }}
              </td>
              <td class="name mousepointer">
                {{ brandingConsultantList.projectName }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No project found.</td>
            </tr>
          </ng-template>
        </p-table>
      </p-popover>
    </div>
    <div>
      <div class="form-group has-float-label">
        <label class="form-label"
          >Accounts coordinator<span class="madatory-field">*</span></label
        >
        <p-select
          pInputText
          [(ngModel)]="bacUserDefaultSelectionId"
          formControlName="accountsCoordinator"
          [ngClass]="{ 'has-error': formErrors['accountsCoordinator'] }"
          (blur)="logValidationErrors()"
          [options]="bacList"
          optionLabel="name"
          optionValue="personnelNumber"
          [filter]="true"
          [showClear]="true">
          <ng-template let-com pTemplate="item">
            {{ com.personnelNumber }} : {{ com.name }}
          </ng-template>
        </p-select>

        <span class="error-msg" *ngIf="formErrors['accountsCoordinator']">
          {{ formErrors["accountsCoordinator"] }}
        </span>
      </div>
    </div>
  </ng-container>

  <!-- Inventory Sales fields — formGroupName="orderDetails" -->
</div>

<!-- Inventory Sales fields — next row -->
<div
  *ngIf="orderType === 'inventory-sales'"
  class="d-flex gap-3 mt-3"
  [formGroup]="parent">
  <ng-container formGroupName="orderDetails">
    <div class="col">
      <div class="form-group has-float-label">
        <label class="form-label"
          >Store<span class="madatory-field">*</span></label
        >
        <p-select
          formControlName="store"
          [options]="storeList"
          optionLabel="storeD365"
          optionValue="storeD365"
          [filter]="true"
          [showClear]="true"
          placeholder="Select Store"
          [ngClass]="{ 'has-error': formErrors['store'] }"
          (onChange)="onStoreChange()">
        </p-select>
        <span class="error-msg" *ngIf="formErrors['store']">{{
          formErrors["store"]
        }}</span>
      </div>
    </div>
    <div class="col">
      <div class="form-group has-float-label">
        <label class="form-label">Site</label>
        <input
          pInputText
          type="text"
          class="form-control"
          formControlName="site"
          [readonly]="true" />
      </div>
    </div>
    <div class="col">
      <div class="form-group has-float-label">
        <label class="form-label"
          >Warehouse<span class="madatory-field">*</span></label
        >
        <p-select
          formControlName="warehouse"
          [options]="warehouseList"
          optionLabel="warehouseIdD365"
          optionValue="warehouseIdD365"
          [filter]="true"
          [showClear]="true"
          placeholder="Select Warehouse"
          [ngClass]="{ 'has-error': formErrors['warehouse'] }"
          (onChange)="onWarehouseChange($event.value)">
        </p-select>
        <span class="error-msg" *ngIf="formErrors['warehouse']">{{
          formErrors["warehouse"]
        }}</span>
      </div>
    </div>
    <div class="col">
      <div class="form-group has-float-label">
        <label class="form-label">Owner</label>
        <p-select
          formControlName="owner"
          [options]="ownerList"
          optionLabel="ownerD365"
          optionValue="ownerD365"
          [filter]="true"
          [showClear]="true"
          placeholder="Select Owner"
          [disabled]="ownerDisabled">
        </p-select>
      </div>
    </div>

    <div class="col"></div>
    <div class="col"></div>
    <div class="col"></div>
    <div class="col"></div>
    <div class="col"></div>
  </ng-container>
</div>

<jni-add-contact-information
  #contactForm
  [(display)]="displayAddContact"
  *ngIf="displayAddContact"
  [headingStatus]="true"
  [isFromOrdersAddNewBuyer]="true"
  [addClientContact]="addClientContact"
  [customerAccountNumber]="customerAccountNumber"
  (isContactAdded)="isContactAdded($event)"
  (populateContactAddedInfo)="populateContactAddedInfo($event)">
</jni-add-contact-information>
